enum TransportationType {
	VESSEL = 'vessel',
	TRUCK = 'truck'
}

export default TransportationType
